module.exports = __webpack_public_path__ + "../resources/img/@temp_chart.473d01f3.jpg";